import { makeStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      width: '100%',
    },
    infoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 36,
      [theme.breakpoints.up('md')]: {
        fontSize: 22,
        flexDirection: 'row',
        alignItems: 'flex-start',
      },
    },
    textInfo: {
      flex: 1,
      [theme.breakpoints.up('md')]: {
        marginLeft: 36,
      },
    },
    avatar: {
      width: 92,
      height: 92,
      borderRadius: '50%',
      marginBottom: SMALL_MARGIN,
      border: `2px solid ${colorsPalette.white}`,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
      },
    },
    name: {
      fontSize: 18,
      lineHeight: 1.2,
      marginBottom: SMALL_MARGIN,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        fontSize: 22,
        textAlign: 'left',
      },
    },
    description: {
      fontSize: 16,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    viewBtn: {
      marginTop: 23,
    },
    videosWrapper: {
      marginBottom: 28,
      transition: 'max-height 0.5s ease-out',
      overflow: 'hidden',
    },
    accordionWrapper: {
      '&:only-child': {
        '& $accordionItem:last-child': {
          marginBottom: 0,
        },
      },
    },
    accordionItem: {},
    tabRoot: {
      marginTop: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginTop: MIDDLE_MARGIN,
      },
    },
    singleTabRoot: {
      maxWidth: 'unset',
    },
  }),
);

export default useStyles;
